import { useMemo } from 'react';

import { createDialog } from 'app-components/flux/root-ui/rootUiActions';

import { useAppDispatch } from 'hooks/redux';

import type { AlertDialogCallback } from 'components/Dialogs/AlertDialog/types';
import { mkDialogAlertData } from './core';
import type { QDialogsProps } from './types';

export type { DialogAlert } from './types';

const useQDialogs = (): QDialogsProps => {
  const dispatch = useAppDispatch();

  return useMemo<QDialogsProps>(
    () => ({
      dialogAlert: (title, content, onClose, ...rest) => {
        // AlertDialog calls back only with one of the given buttons, or Escape.
        const callback = onClose as AlertDialogCallback | null | undefined;
        dispatch(createDialog(mkDialogAlertData(title, content, callback, ...rest)));
      },
    }),
    [dispatch],
  );
};

export default useQDialogs;
